<template>
  <div class="bm-bd-agent">
    <div class="avator-box">
      <div class="content-avator">
        <img :src="imageView(currentBd.icon, 182, 182)">
      </div>
    </div>
    <!-- 白色区域-->
    <div class="content-info">
      <div class="house-manage">
        <div class="manage-name">{{ currentBd.name }}</div>
        <div class="manage-state">
          <div>专属顾问</div>
        </div>
      </div>
      <div class="phone">{{ currentBd.mobile }}</div>
      <div class="display">
        <img src="../../assets/images/left-cont-ico.png" class="left-ico">
        <div class="introduce">
          <span>{{ currentBd.desc }}</span>
        </div>
        <img src="../../assets/images/right-cont-ico.png" class="right-ico">
      </div>
      <ul class="achievement">
        <li v-for="(item, index) in currentBd.content" :key="index">
          <div class="dot"></div>
          <span class="data">{{ item }}</span>
          <!--            <span class="achieve">hhhhhhhh</span>-->
        </li>
      </ul>
      <div class="soft-code">
        <img :src="imageView(currentBd.wx, 180, 180)">
      </div>
      <div class="tips">
        <div class="line"></div>
        <div class="text" v-if="currentBd.name === '李光泽'">免费直播体验 · 扫码领取</div>
        <div class="text" v-else>{{ isWx ? '长按二维码，添加专属顾问' : '分享到微信，扫码添加专属顾问' }} </div>
        <div class="line"></div>
      </div>
    </div>
    <div class="footer-box">
      <img src="../../assets/images/bmb-footer-logo.png">
    </div>
  </div>
</template>

<script>
import { ImageFormat, AppType } from '@/utils'

const bdList = [
  {
    icon: 'FiY9Wu3k3NQKTCMcmcE-ctAOPJll',
    name: '李光泽',
    mobile: '18659928276',
    desc: '不忘初心，砥砺前行。为每个赛事组织机构提供优质高效的真诚服务！',
    content: [
      '斑马邦华南区赛事合作商务主管',
      '2019年斑马邦TOP Sales',
      '累计服务合作40万+场赛事'
    ],
    wx: 'FgJyHIvFnQoBnW5UeU3BX8Q1Sc8D'
  },
  {
    icon: 'FiY9Wu3k3NQKTCMcmcE-ctAOPJll',
    name: '李光泽',
    mobile: '18659928276',
    desc: '不忘初心，砥砺前行。为每个赛事组织机构提供优质高效的真诚服务！',
    content: [
      '斑马邦华南区赛事合作商务主管',
      '2019年斑马邦TOP Sales',
      '累计服务合作40万+场赛事'
    ],
    wx: 'FgJyHIvFnQoBnW5UeU3BX8Q1Sc8D'
  },
  {
    icon: 'Fq90OhSS1XXxU5LmSOKYKeUMRCfQ',
    name: '温小丽(Lily)',
    mobile: '13816768465',
    desc: '不忘初心，砥砺前行。为每个球队，社团提供优质高效的真诚服务！',
    content: [
      '斑马邦社群运营总监',
      '斑马邦产业合作伙伴',
      '累计服务用户数10W+'
    ],
    wx: 'FvtSmA79uQe4rQjqQH_5dklifXJx'
  }
]
export default {
  name: 'BdAgent',
  data() {
    return {
      query: '',
      currentBd: {},
      isWx: false
    }
  },
  mounted() {
    this.query = this.$route.query
    let typeIndex = Number(this.query.bdRegion)
    if (!this.query.bdRegion || this.query.bdRegion === 'undefined') {
      this.query.bdRegion = '1'
      typeIndex = 1
    }
    this.isWx = AppType.isInWeChat()
    this.currentBd = bdList[typeIndex]
    // 分享文案
    this.shareData = {
      title: '斑马邦赛事管家竭诚为您服务',
      link: this.getShareLink(),
      image: ImageFormat.squareImageView('FiyWzstnQ98KV_cqnYgPkCljISPc', 120),
      abstract: '扫码添加您的专属赛事管家，随时在线答疑'
    }
    this.wxShare(this.shareData)
  },
  methods: {
    imageView(hash, w, h, mode, format) {
      return ImageFormat.imageView(hash, w, h, mode, format)
    },
    getShareLink: function () {
      const arr = window.location.href.split('index.html')
      return arr[0] + 'index.html#/customer-service/bd-agent?dsbridge=1&bdRegion=' + this.query.bdRegion
    }
  }
}
</script>

<style lang="scss">
body,
html {
  background: #ffffff !important;
}

.bm-bd-agent {
  position: relative;
  padding-top: 26px;
  padding-bottom: 26px;
  box-sizing: border-box;
  height: 100%;
  overflow-x: hidden;

  .avator-box {
    height: 52px;

    .content-avator {
      width: 100px;
      height: 100px;
      box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.12);
      background-color: #fff;
      border-radius: 50%;
      position: absolute;
      left: 50%;
      margin-left: -50px;
      z-index: 99;

      img {
        width: 91px;
        height: 91px;
        border-radius: 50%;
        margin: 5px;
      }
    }
  }

  .content-info {
    width: 320px;
    min-height: 450px;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.12);
    background-color: #ffffff;
    border-radius: 4px;
    position: relative;
    left: 50%;
    margin-left: -160px;
    margin-bottom: 68px;

    .house-manage {
      padding-top: 54px;
      box-sizing: border-box;
      display: flex;
      align-items: center;

      .manage-name {
        font-size: 16px;
        color: #2B2B2B;
        margin-left: 131px;
      }

      .manage-state {
        width: 50px;
        height: 18px;
        border: 1px solid #5261F9;
        color: #5261F9;
        border-radius: 2px;
        font-size: 10px;
        text-align: center;
        line-height: 22px;
        margin-left: 5px;
      }
    }

    .phone {
      text-align: center;
      font-size: 16px;
      color: #999999;
      margin-top: 7px;
    }

    .display {
      display: flex;
      padding: 16px 28px;
      box-sizing: border-box;
      position: relative;

      .introduce {
        font-size: 14px;
        color: #2B2B2B;
      }

      img {
        width: 8px;
        height: 9px;
      }

      .left-ico {
        margin-bottom: 10px;
        margin-right: 4px;
      }

      .right-ico {
        margin-top: 10px;
        position: absolute;
        right: 18px;
        bottom: 16px;
      }
    }

    .achievement {
      width: 298px;
      min-height: 29px;
      background-color: #F3F3F3;
      margin: 0 auto;
      font-size: 12px;
      color: #999999;
      border-radius: 4px;
      padding: 12px 14px;
      box-sizing: border-box;

      li {
        display: flex;
        margin-top: 6px;
        align-items: center;

        .dot {
          width: 5px;
          height: 5px;
          border-radius: 50%;
          background-color: #4C4C4C;
          margin-right: 6px;
        }
      }

      .data {
        margin-right: 14px;
      }
    }

    .soft-code {
      width: 100px;
      height: 100px;
      border: 1px solid #DFDFDF;
      margin: 14px auto;

      img {
        width: 90px;
        height: 90px;
        margin: 5px;
        text-align: center;
      }
    }

    .tips {
      display: flex;
      align-items: center;
      color: #999999;
      font-size: 12px;
      justify-content: center;
      margin-top: 17px;
      margin-bottom: 16px;

      .line {
        width: 50px;
        height: 1px;
        background-color: #DFDFDF;
      }

      .text {
        margin: 0 24px;
      }
    }
  }

  .footer-box {
    position: relative;
    bottom: 22px;
    left: 50%;
    margin-left: -37px;

    img {
      width: 74px;
      height: 24px;
      vertical-align: middle;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/customer-service/bd-agent.vue